import React from 'react';

import Gallery from 'react-photo-gallery';
import moment from 'moment';

import { strings } from 'APP_ROOT/localization';
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';

import SelectableImage from './SelectableImage';

const FlatSelectableImage = SelectableImage({ baseClassName: 'single', showUnselectedCheck: false });

/**
 * FaceImageGallery displays images associated with a face.
 * It allows selecting multiple images and provides a delete button delete
 * selected images, using the deleteIdentityFaces lambda.  The delete button
 * is disabled when no images are selected.
 **/
export default class FaceImageGallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            confirmModalOpen: false,
            confirmUnassignModalOpen: false,
            selectedImageIds: [],
        }
    }

    openConfirmModal = (event) => {
        event.preventDefault();
        this.setState({ confirmModalOpen: true });
    }

    closeConfirmModal = (event) => {
        event.preventDefault();
        this.setState({ confirmModalOpen: false });
    }

    openUnassignConfirmModal = (event) => {
        event.preventDefault();
        this.setState({ confirmUnassignModalOpen: true });
    }

    closeUnassignConfirmModal = (event) => {
        event.preventDefault();
        this.setState({ confirmUnassignModalOpen: false });
    }

    toggleImageSelected = (event, { index }) => {
        const { images } = this.props;
        const { selectedImageIds } = this.state;
        if(images && images[index]) {
            const imageId = images[index].faceId;
            const selectedImageIdsMutated = selectedImageIds.filter(el => el !== imageId);
            if(selectedImageIdsMutated.length === selectedImageIds.length) {
                selectedImageIdsMutated.push(imageId);
            }
            this.setState({
                selectedImageIds: selectedImageIdsMutated
            });
        }
    };

    deleteImages = (e) => {
        e.preventDefault();

        const { selectedImageIds } = this.state;

        this.setState({
            confirmModalOpen:false,
            selectedImageIds: []
        });

        this.props.onRequestDeleteImages(selectedImageIds);
    }

    unassignImages = (e) => {
        e.preventDefault();

        const { selectedImageIds } = this.state;

        this.setState({
            confirmUnassignModalOpen:false,
            selectedImageIds: []
        });

        this.props.onRequestUnassignImages(selectedImageIds);
    }

    handleSetAsProfile = e => {
        e.preventDefault();
        const { selectedImageIds } = this.state;
        if (selectedImageIds && selectedImageIds.length) {
            this.props.setAsProfile(selectedImageIds[0]).then(() => {
                this.setState({
                    selectedImageIds: []
                });
            });
        }
    }


    render() {
        const { images } = this.props;
        if (!images || !images.length) return null;
        const { confirmModalOpen, selectedImageIds } = this.state;
        const photos = images.map(image => {
            return {
                key: image.faceId,
                selected: selectedImageIds.includes(image.faceId),
                src: image.secureImageUrl,
                width:1,
                height:1,
                title: moment.utc(image.detectedTime).local().format("YYYY-MM-DD hh:mm:ss A")
            };
        });
        const setAsProfileEnabled = images && selectedImageIds.length === 1;
        const deletFacesEnabled = images && selectedImageIds.length > 0;

        return (
            <div className="row">
                <div className="col-12 image-gallery-wrapper">
                    <Gallery
                        photos={photos}
                        onClick={this.toggleImageSelected}
                        ImageComponent={FlatSelectableImage}
                    />
                </div>
                <div className="col-12 action-btns text-right">
                    <button disabled={!setAsProfileEnabled} className="btn btn-sm" onClick={this.handleSetAsProfile}>
                        <i className="material-icons">person</i>
                        Use as Profile Image
                    </button>
                    <button disabled={!deletFacesEnabled} className="btn btn-sm" onClick={this.openUnassignConfirmModal}>
                        <i className="material-icons">person_off</i>
                        {strings.faces_unassign_action}
                    </button>
                    <button disabled={!deletFacesEnabled} className="btn btn-sm" onClick={this.openConfirmModal}>
                        <i className="material-icons">delete</i>
                        {strings.faces_delete_selected_action}
                    </button>
                </div>
                <ConfirmDialog
                    isOpen={confirmModalOpen}
                    contentLabel="confirm-delete-images"
                    title={strings.faces_confirm_delete_images_title}
                    message={strings.formatString(strings.faces_confirm_delete_x_images_message_other, selectedImageIds.length)}
                    onOk={this.deleteImages}
                    onCancel={this.closeConfirmModal}
                    onDismiss={this.closeConfirmModal}
                />
                <ConfirmDialog
                    isOpen={this.state.confirmUnassignModalOpen}
                    contentLabel="confirm-unassign-images"
                    title={strings.faces_unassign_action}
                    message={strings.formatString(strings.faces_confirm_unassign_x_images_message_other, selectedImageIds.length)}
                    onOk={this.unassignImages}
                    onCancel={this.closeUnassignConfirmModal}
                    onDismiss={this.closeUnassignConfirmModal}
                />
            </div>
        );
    }
}
